module.exports = __webpack_public_path__ + "img/user-manual.svg";